<template>
    <Card :title="$t('labels.sms_template')">
        <div class="card-body">
            <MainInformationCard
                :sms-template="smsTemplate"
                :formula-items="formulaItems"
                @update:sms-template="smsTemplate = $event"
            />
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="list-icons text-muted">
                <span class="list-icons-item">
                    <i class="icon-plus3 mr-2"></i> {{ DateFormatter.formatDateTime(createdAt) }}
                </span>

                <span class="list-icons-item ml-3">
                    <i class="icon-pencil mr-2"></i> {{ DateFormatter.formatDateTime(updatedAt) }}
                </span>
            </div>
            <div class="d-flex flex-wrap justify-content-end" style="gap: .5rem;">
                <AppButton color="light" @click="removeSmsTemplate">
                    <i class="icon-trash mr-2"></i>
                    {{ $t('buttons.delete') }}
                </AppButton>
                <AppButton color="indigo" @click="editSmsTemplate">
                    <i class="icon-floppy-disk mr-2"></i>
                    {{ $t('buttons.edit') }}
                </AppButton>
            </div>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import Formula from "../../../../components/form/FormulaComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import AppAutoComplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";

import { httpClient } from "../../../../services/HttpClient";
import MessageNotificator from "../../../../services/MessageNotificator";
import DateFormatter from "../../../../services/DateFormatter";
import AppCheckbox from "../../../../components/new/form/checkbox/AppCheckbox.vue";

import MainInformationCard from "./components/MainInformationCard.vue";

export default {
    name: "SmsTemplatesEditPage",
    components: {
        MainInformationCard, AppCheckbox, Card, FormGroup, Input, Formula, AppButton, AppAutoComplete
    },
    data() {
        return {
            DateFormatter,
            smsTemplate: null,
            orderCustomFields: [],
        }
    },
    methods: {
        fetchSmsTemplate() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/sms-templates/${this.$route.params.smsTemplateUuid}`).then((response) => {
                this.smsTemplate = response.data.data;
            })
        },
        fetchOrderCustomFields() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`, {
                limit: 100
            }).then((response) => {
                this.orderCustomFields = response.data.data
            })
        },
        editSmsTemplate() {
            httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/sms-templates/${this.$route.params.smsTemplateUuid}`, {
                name: this.smsTemplate.name,
                api_credentials_uuid: this.smsTemplate?.api_credentials?.uuid,
                text: this.smsTemplate.text,
                sender_name: this.smsTemplate.sender_name,
                send_once: this.smsTemplate.send_once
            }).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            })
        },
        removeSmsTemplate() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: `${this.$t('labels.sms_template')}`
            }), async () => {
                await httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/sms-templates/${this.$route.params.smsTemplateUuid}`).then(() => {
                    this.$router.replace({
                        name: 'SmsTemplatesIndexPage'
                    })
                })
            })
        }
    },
    computed: {
        formulaItems() {
            let items = [
                {code: '{$deliveryCompanyNumber}', name: this.$t('labels.ttn')},
                {code: '{$orderSum}', name: this.$t('labels.order_sum')},
                {code: '{$orderExternalId}', name: this.$t('labels.order_external_id')},
            ];

            this.orderCustomFields.forEach((field) => {
                items.push({
                    name: field.name,
                    code: `{$customField[${field.uuid}]}`
                });
            });

            return items;
        }
    },
    mounted() {
        this.fetchSmsTemplate();
        this.fetchOrderCustomFields();
    }
}
</script>
